// Imports
var ___HTML_LOADER_IMPORT_0___ = new URL("./img/tiles-view.svg", import.meta.url);
var ___HTML_LOADER_IMPORT_1___ = new URL("./img/table-view.svg", import.meta.url);
var ___HTML_LOADER_IMPORT_2___ = new URL("./img/stats-view.svg", import.meta.url);
// Module
var code = `<div class="container">
  <hs-toolbar-button class="selectable" icon="${___HTML_LOADER_IMPORT_0___}" action="hs-tiles-view"></hs-toolbar-button>
  <hs-toolbar-button class="selectable" icon="${___HTML_LOADER_IMPORT_1___}" action="hs-table-view"></hs-toolbar-button>
  <hs-toolbar-button class="selectable" icon="${___HTML_LOADER_IMPORT_2___}" action="hs-stats-view"></hs-toolbar-button>
</div>
`;
// Exports
export default code;